// French (FR) translations for Find-2-Day
const fr = {
  translation: {
    "partnersStep3": "Lorsqu'une entreprise que vous avez recommandée paie — son premier abonnement, un renouvellement ou une mise en avant — vous gagnez 50% de ce paiement (hors TVA). Cela apparaît automatiquement dans votre Tableau de bord Partenaire, à chaque paiement.",
    "partnersLede": "Vous êtes Ambassadeur de votre ville, groupe communautaire ou acteur local ? Présentez les entreprises proches à Find-2-Day : vous gagnez 50% de chaque paiement qu'elles effectuent (hors TVA), tant qu'elles restent : leur premier abonnement, chaque renouvellement et chaque mise en avant ou publication sponsorisée.",
    "partnersCommissionExplainer": "Vous gagnez 50% de tout ce que paie une entreprise que vous avez recommandée : son premier abonnement, chaque renouvellement mensuel ou annuel, et chaque mise en avant ou publication sponsorisée. Les prix incluent 21% de TVA ; votre commission est calculée sur le montant hors TVA.",
    "partnersRenewalHeading": "Abonnements et renouvellements",
    "partnersRenewalDesc": "50% du premier paiement et de chaque renouvellement d'une entreprise recommandée, tant qu'elle reste abonnée.",
    "partnersPoint2": "Dès qu'elle paie un abonnement, un renouvellement, une mise en avant ou une publication sponsorisée, vous recevez 50% du montant payé (hors TVA).",
    "partnersPoint3": "Chaque entreprise que vous apportez vous est attribuée à vie. Tant qu'elle continue de payer, vous continuez de gagner 50%, à vie.",
    "affEarnTitle": "Ce que vous gagnez par formule",
    "affEarnIntro": "Les prix incluent 21% de TVA. Votre commission de 50% est calculée sur le montant hors TVA. Les abonnements éligibles vous rémunèrent à vie : le premier paiement et chaque renouvellement.",
    "affEarnColPlan": "Formule",
    "affEarnColPrice": "Prix (TVA incl.)",
    "affEarnColCommission": "Votre commission (par paiement)",
    "affEarnPerMonth": "/mois",
    "affEarnPerYear": "/an",
    "affEarnPlanBasic": "Basic",
    "affEarnPlanPlus": "Business Plus",
    "affEarnLifetimeNote": "Vous gagnez la commission ci-dessus sur leur premier paiement et sur chaque renouvellement, tant qu'ils restent abonnés.",
    "affEarnBoostNote": "Mises en avant et publications sponsorisées : vous gagnez aussi 50% de chaque mise en avant ou publication sponsorisée payée par une entreprise recommandée.",
    "verifyEmailWarn": "Veuillez vérifier votre e-mail pour activer le versement des commissions.",
    "resendVerification": "Renvoyer l'e-mail",
    "sending": "Envoi…",
    "verifyResent": "E-mail de vérification envoyé — vérifiez votre boîte de réception.",
    "payoutHoldWarn": "Vos coordonnées bancaires ont changé récemment ; les paiements sont donc brièvement suspendus par sécurité.",
    "clawbackWarn": "Un solde impayé de {{amt}} € issu d'un remboursement/rétrofacturation sera déduit des commissions futures.",
    "downloadEarnings": "Relevé des gains (CSV)",
    "downloadPayouts": "Relevé des versements (CSV)",
    "partnersPoint1": "Les entreprises peuvent rejoindre Find-2-Day avec une fiche d'annuaire de base GRATUITE et permanente. Des abonnements payants et des services promotionnels sont proposés en option. Les entreprises fondatrices existantes conservent les 12 mois gratuits promis à l'origine.",
    "partnersPoint4": "Les commissions sont retenues pendant 30 jours. Si un paiement est remboursé ou contesté avec succès, sa commission peut être annulée. Les commissions déjà versées peuvent être déduites des gains futurs.",
    "howPayoutsRule6": "Si un paiement est remboursé ou contesté avec succès, sa commission peut être annulée — y compris les commissions déjà versées, qui peuvent être déduites des gains futurs.",
    "lifetimeRenewalEarningsHint": "Vous commencerez à gagner cela lorsque vos entreprises recommandées renouvelleront. Rien de plus à faire — nous le suivons pour vous.",
    "renewalCommissionTooltip": "Commission gagnée car cette entreprise a renouvelé son abonnement",
    "communityPartner": {
      "title": "Devenez Partenaire Communautaire",
      "label": "Devenez Partenaire Communautaire",
      "tagline": "Gagnez ",
      "taglineRest": " de commission à vie sur tout ce que paient les entreprises que vous recommandez (hors TVA).",
      "cta": "En savoir plus"
    },
    "membership": {
      "chooseTitle": "Choisissez votre abonnement",
      "chooseSubtitle": "Commencez gratuitement ou débloquez votre profil complet. Prix TVA incluse.",
      "freeForever": "Gratuit pour toujours · sans carte",
      "chooseFree": "Choisir l'annuaire gratuit",
      "month": "mois",
      "year": "an",
      "trial60": "60 premiers jours gratuits",
      "ivaIncluded": "TVA incluse",
      "chooseBasic": "Choisir Basic",
      "plusName": "Business Plus",
      "orAnnual": "ou",
      "choosePlusMonthly": "Mensuel",
      "choosePlusAnnual": "Annuel",
      "consentNote": "Les offres payantes commencent par un essai gratuit de 60 jours. Vous ne serez pas débité avant la fin de l'essai, et uniquement si vous avez donné votre consentement. Annulez à tout moment.",
      "freeBadge": "Annuaire gratuit",
      "freeTitle": "Fiche gratuite — €0 pour toujours",
      "freeBody": "Votre fiche de base (nom de l'entreprise, catégorie et ville) est publiée après approbation. Sans carte. Vous pouvez passer à Basic ou Business Plus à tout moment pour afficher toutes vos informations.",
      "paidBody": "Votre fiche est publiée après approbation. Vous ne serez PAS débité pendant les 60 premiers jours. À la fin de l'essai gratuit, votre carte est débitée automatiquement uniquement si vous avez consenti, et vous pouvez annuler à tout moment avant.",
      "firstChargeOn": "Premier débit (si vous continuez) :",
      "checkoutNotReady": "Le paiement sécurisé par carte pour les offres payantes sera activé à l'étape suivante (mode test Stripe). Vos informations d'inscription sont complètes et prêtes ; aucun débit n'a été effectué.",
      "freeCta": "Créer ma fiche gratuite",
      "paidCta": "Continuer — démarrer mes 60 jours gratuits",
      "freeName": "Annuaire gratuit",
      "basicName": "Basic",
      "feat": {
        "free": ["Nom de l'entreprise", "Catégorie", "Ville", "Visibilité de base dans l'annuaire"],
        "basic": ["60 premiers jours gratuits", "Description complète de l'entreprise", "Téléphone et coordonnées", "Site web et réseaux sociaux", "Photos de l'entreprise", "Adresse, carte et itinéraire", "Visibilité standard dans les recherches"],
        "plus": ["60 premiers jours gratuits", "Tout de l'offre Basic", "Badge Business Plus", "Promouvoir événements et offres spéciales"]
      }
    },
    "listShare": {
      "today": "Courses du Jour",
      "todayHint": "Vos courses actuelles · comparez les prix",
      "myLists": "Mes Listes",
      "noLists": "Créez des listes pour tout : courses, bricolage, bois de chauffage, animaux, jardin…",
      "newList": "Nouvelle Liste",
      "namePh": "Nom de la liste (ex. Courses de la semaine, Bricolage, Bois)",
      "nameRequired": "Veuillez nommer la liste",
      "kind_personal": "Personnelle",
      "kind_calendar": "Foyer",
      "kind_direct": "Partagée",
      "hintPersonal": "Privée, pour vous seul.",
      "hintCalendar": "Partagée avec tous les membres de ce calendrier.",
      "hintDirect": "Partagez avec des personnes précises par e-mail.",
      "pickCalendar": "Choisir un calendrier…",
      "create": "Créer",
      "created": "Liste créée",
      "rename": "Renommer",
      "delListConfirm": "Supprimer cette liste ? Ses articles seront retirés.",
      "share": "Partager avec quelqu'un",
      "shared": "Liste partagée",
      "invite": "Inviter",
      "emailPh": "E-mail de l'utilisateur Find-2-Day",
      "editingShared": "Vous travaillez sur une liste partagée",
      "shareHelp": "Les personnes que vous invitez peuvent voir et modifier cette liste, et peuvent voir les noms et adresses e-mail des autres personnes qui la partagent.",
      "remove": "Retirer",
      "addToWhich": "Ajouter à…",
      "addedToList": "{{n}} ajouté(s) à {{list}}",
      "addToListN": "Ajouter à la liste ({{n}})",
      "copySelectedToList": "Copier vers la liste ({{n}})",
      "listEmpty": "Aucun produit pour l'instant. Ajoutez ce que vous achetez.",
      "select": "Sélectionner",
      "compareThis": "Comparer Cette Liste",
      "addAll": "Ajouter toute la liste",
      "addSelected": "Ajouter la sélection ({{n}})",
      "addSelectedShort": "Ajouter la sélection",
      "addWholeShop": "Ajouter toutes les courses",
      "pickItems": "Cochez les articles dont vous avez besoin",
      "copiedToday": "{{n}} ajouté(s) aux Courses du Jour",
      "itemsN": "{{n}} articles",
      "repeatShop": "Répéter les Dernières Courses",
      "repeatHint": "Ajoutez des articles de votre dernier ticket",
      "repeatEmpty": "Aucune course précédente trouvée. Scannez d'abord un ticket.",
      "favourite": "Favori",
      "favAdded": "Ajouté aux Favoris",
      "favRemoved": "Retiré des Favoris"
    },
    "priceEdit": {
      "title": "Détails du prix", "edit": "Modifier le prix", "delete": "Supprimer", "save": "Enregistrer les modifications", "cancel": "Annuler",
      "confirmDelete": "Supprimer définitivement ce prix ? Cette action est irréversible.", "confirmYes": "Oui, supprimer",
      "productName": "Nom du produit", "price": "Prix", "brand": "Marque", "packSize": "Format / taille", "quantity": "Quantité",
      "shop": "Fournisseur / magasin", "town": "Ville / lieu", "date": "Date enregistrée", "notes": "Notes",
      "notesPh": "ex. en promotion, prix fidélité, grand format…", "optional": "facultatif",
      "saved": "Prix mis à jour", "deleted": "Prix supprimé",
      "errName": "Veuillez saisir un nom de produit", "errPrice": "Veuillez saisir un prix valide",
      "errSave": "Impossible de mettre à jour le prix", "errDelete": "Impossible de supprimer le prix"
    },
    "priceHistory": {
      "title": "Historique des prix", "none": "Pas encore d'historique de prix",
      "noneHint": "Dès qu'il y aura plus de prix enregistrés pour ce produit dans ce magasin, une tendance apparaîtra ici.",
      "latest": "DERNIER", "rose": "Prix en hausse", "fell": "Prix en baisse", "flat": "À peu près identique"
    },
    "pricePromo": {
      "title": "Promotions Price-2-Day",
      "subtitle": "Mettez en avant une offre produit auprès des acheteurs à proximité",
      "slots": "Emplacements",
      "suspendedNote": "Votre entreprise est actuellement suspendue des promotions. Contactez le support.",
      "new": "Nouvelle promotion",
      "embedTitle": "Mes promotions",
      "promoteItem": "Promouvoir un article",
      "boostAgain": "Relancer",
      "noSlots": "Plus d'emplacement disponible. Archivez-en une active pour libérer un emplacement.",
      "editTitle": "Modifier la promotion",
      "createTitle": "Créer une promotion",
      "product": "Produit",
      "productPh": "ex. Huile d'olive 2L",
      "brand": "Marque",
      "pack": "Format / taille",
      "normalPrice": "Prix normal",
      "promoPrice": "Prix promotionnel",
      "description": "Description",
      "town": "Ville / zone",
      "branch": "Magasin / succursale",
      "optional": "facultatif",
      "start": "Date de début",
      "end": "Date de fin",
      "availability": "Texte de disponibilité",
      "availabilityPh": "ex. Jusqu'à épuisement des stocks",
      "photo": "Photo",
      "photoError": "Impossible de téléverser la photo",
      "save": "Enregistrer",
      "publish": "Publier",
      "updated": "Promotion mise à jour",
      "published": "La promotion est maintenant en ligne",
      "submitted": "Promotion soumise pour examen",
      "archived": "Promotion archivée",
      "viewActive": "Actives",
      "viewExpired": "Expirées",
      "empty": "Aucune promotion ici pour l'instant.",
      "ends": "se termine",
      "sponsored": "Sponsorisé",
      "sponsoredHint": "Offre payante — ne fait pas partie de la comparaison de prix",
      "needProduct": "Veuillez saisir un nom de produit",
      "needPromoPrice": "Veuillez saisir un prix promotionnel",
      "needEnd": "Veuillez choisir une date de fin",
      "saveError": "Impossible d'enregistrer la promotion",
      "needDuration": "Veuillez choisir une durée de promotion",
      "publishedFree": "Votre promotion GRATUITE est maintenant en ligne",
      "ended": "Promotion terminée",
      "startHint": "laisser vide pour aujourd'hui",
      "duration": "Durée de la promotion",
      "days": "jours",
      "free": "GRATUIT",
      "willEnd": "Se termine",
      "testMode": "Mode test aperçu — prix affiché, aucun débit réel",
      "introAvailable": "Votre première promotion de 7 jours est GRATUITE (une par entreprise).",
      "introUsed": "Promotion d'introduction gratuite utilisée.",
      "viewLive": "En ligne",
      "viewScheduled": "Programmées",
      "edit": "Modifier",
      "endEarly": "Terminer plus tôt",
      "archive": "Archiver",
      "status": { "live": "En ligne", "scheduled": "Programmée", "pending": "En attente", "suspended": "Suspendue", "expired": "Expirée", "archived": "Archivée" }
    },
    "price": {
      "tagline": "Scannez un ticket pour lire ses prix",
      "homeHeadline": "Économisons ensemble",
      "homeTagline": "De vrais prix. De vraies personnes. Une communauté plus forte.",
      "homeIntro": "Scannez vos tickets, partagez les prix, comparez les magasins et aidez tout le monde à trouver les meilleures offres.",
      "actListTitle": "Ma liste de courses",
      "actListSub": "Qu'est-ce que je dois acheter ?",
      "actSearchTitle": "Trouver le prix le moins cher",
      "actSearchSub": "Comparez les prix près de chez vous",
      "actScanTitle": "Scanner et partager les prix",
      "actScanSub": "Ajouter les prix de mes courses",
      "helpTitle": "Vos tickets aident tout le monde !",
      "helpBody": "Quand vous scannez le ticket de vos courses, nous utilisons uniquement les informations sur les produits et les prix pour vous aider, vous et les autres, à trouver les meilleures offres.",
      "helpPrivacy": "Nous ne collectons ni n'enregistrons JAMAIS vos données personnelles, vos informations de paiement/carte ou l'image du ticket.",
      "buyOftenTitle": "Ce que j'achète souvent",
      "buyOftenSub": "Ajouter vite à ma liste",
      "dealsBtnTitle": "Offres du jour",
      "dealsBtnSub": "Offres spéciales près de chez vous",
      "backToMenu": "Retour",
      "scanWhyTitle": "Aidez tout le monde à économiser",
      "scanWhyBody": "Scannez le ticket de vos courses et nous lirons les prix. Vos prix vous aident, vous et les autres membres de la communauté, à voir où les produits sont les moins chers.",
      "savedCommunityTitle": "Merci ! \u2764\ufe0f",
      "savedCommunityBody": "Vos prix ont été ajoutés. Vous venez d'aider d'autres acheteurs à trouver de meilleurs prix.",
      "slAddHeading": "De quoi avez-vous besoin ?",
      "quickAddTitle": "Ajout rapide",
      "regularTitle": "Ce que j'achète régulièrement",
      "addToListBtn": "Ajouter",
      "buyOftenEmpty": "Les produits que vous achetez souvent apparaîtront ici, prêts à ajouter d'un seul geste.",
      "manageProductsLink": "Gérer mes produits enregistrés",
      "addedToListToast": "Ajouté à votre liste de courses",
      "tabScan": "Scanner",
      "tabSearch": "Rechercher",
      "tabFav": "Favoris",
      "tabDeals": "Offres",
      "dist": { "pick": "Choisissez votre commune pour voir les distances", "list": "Liste", "map": "Carte", "soon": "Bientôt", "directions": "Itinéraire", "unavailable": "Emplacement pas encore disponible", "approxTravel": "Trajet approx.", "extraTravel": "Trajet suppl. approx.", "productSaving": "Économie produits", "vsOne": "vs Un magasin", "partial": "Certains emplacements pas encore disponibles", "nearestNone": "Aucun magasin localisé de façon fiable pour ces articles pour l'instant", "knownFor": "Prix récents connus pour {{covered}}/{{total}} articles" },
      "reviewNote": "Vérifiez ce que l'IA a lu, corrigez les erreurs puis enregistrez. La photo du ticket n'est jamais conservée — seulement les prix.",
      "scanTitle": "Scanner le ticket",
      "scanBlurb": "Photographiez un ticket ou choisissez-en un sur votre téléphone. Fonctionne avec tout magasin et toute langue.",
      "receiptPrivacy": "Confidentialité du ticket : Votre ticket sert uniquement à lire les informations de produits et de prix. L'image du ticket n'est pas affichée publiquement et n'est pas conservée de façon permanente par Price-2-Day. Les informations personnelles et de paiement ne sont pas ajoutées à la base de données de prix de Price-2-Day.",
      "signInToScan": "Connectez-vous pour scanner et envoyer un ticket.",
      "signIn": "Se connecter",
      "takePhoto": "Prendre une photo",
      "choosePhoto": "Choisir une photo existante",
      "readingReceipt": "Lecture du ticket…",
      "receiptPreviewAlt": "aperçu du ticket",
      "reviewTitle": "Vérifier et corriger",
      "reviewSubtitle": "Modifiez tout champ mal lu par l'IA.",
      "fShop": "Magasin",
      "fLocation": "Lieu / agence",
      "fDate": "Date",
      "fCurrency": "Devise",
      "fTotal": "Total du ticket",
      "itemsLabel": "ARTICLES ({{count}})",
      "noItems": "Aucun article reconnu.",
      "itemN": "Article {{n}}",
      "removeItem": "Supprimer l'article",
      "fDesc": "Description (telle qu'imprimée)",
      "fBrand": "Marque",
      "fPackSize": "Format / conditionnement",
      "fQty": "Quantité",
      "fUnitPrice": "Prix unitaire",
      "fLineTotal": "Total ligne",
      "fDiscount": "Remise / offre",
      "confirmSave": "Confirmer et enregistrer les prix",
      "saving": "Enregistrement…",
      "cancel": "Annuler",
      "signInHint": "Vous devez vous connecter pour enregistrer.",
      "savedTitle": "Ticket ajouté avec succès",
      "savedBody": "Merci pour votre contribution. Vous pouvez ajouter autant de tickets que vous voulez.",
      "scanAnother": "Scanner un autre ticket",
      "searchPlaceholder": "Rechercher un produit, ex. Huile d'olive ou ACEITE",
      "searchBtn": "Rechercher",
      "sortLabel": "Trier :",
      "sortLowest": "Prix le plus bas",
      "sortRecent": "Plus récent",
      "sortNearest": "Le plus proche",
      "noResults": "Aucun produit correspondant. Essayez d'autres mots.",
      "asPrinted": "tel qu'imprimé",
      "lowestPrice": "Prix le plus bas",
      "lowestUnit": "Prix unitaire le plus bas",
      "unknownShop": "Magasin inconnu",
      "shopsCount": "{{count}} magasin(s)",
      "receiptDated": "Ticket daté du",
      "offer": "Offre",
      "freshRecent": "Récent",
      "freshOlder": "Ancien",
      "freshHistorical": "Historique",
      "freshUnknown": "Inconnu",
      "disclaimer": "Les prix affichés sur Price-2-Day proviennent d'informations fournies par la communauté. Ils peuvent être obsolètes ou varier selon le magasin et le moment. Vérifiez toujours en magasin avant l'achat.",
      "errMin2": "Saisissez au moins 2 caractères pour rechercher.",
      "errHeic": "Impossible de lire ce format de photo. Essayez JPG ou PNG.",
      "errChooseImage": "Veuillez choisir une image de ticket.",
      "errNoData": "Aucune donnée n'a pu être extraite. Essayez une photo plus nette.",
      "errScan": "Impossible de lire le ticket. Veuillez réessayer.",
      "errNoItems": "Ajoutez au moins un article avec une description avant d'enregistrer.",
      "errSignIn": "Connectez-vous pour enregistrer les prix du ticket.",
      "errDuplicate": "Vous avez déjà soumis ce ticket.",
      "errSaveGeneric": "Enregistrement impossible. Veuillez réessayer.",
      "errSearch": "Échec de la recherche. Veuillez réessayer.",
      "tabProducts": "Mes produits",
      "tabList": "Liste de courses",
      "signInCta": "Se connecter",
      "errGeneric": "Une erreur est survenue. Veuillez réessayer.",
      "edit": "Modifier",
      "delete": "Supprimer",
      "back": "Retour",
      "mpSignIn": "Connectez-vous pour conserver votre liste privée de produits achetés.",
      "mpAddTitle": "Ajouter un produit",
      "mpNamePh": "Nom du produit (ex. Lait)",
      "mpBrandPh": "Marque (facultatif)",
      "mpPackPh": "Format/emballage (facultatif)",
      "mpAddBtn": "Ajouter",
      "mpFromReceipt": "Depuis un ticket",
      "mpNameRequired": "Veuillez saisir un nom de produit.",
      "mpDuplicate": "Ce produit est déjà dans Mes produits.",
      "mpAdded": "Ajouté à Mes produits.",
      "mpEmpty": "Aucun produit pour l'instant. Ajoutez ce que vous achetez régulièrement.",
      "mpToList": "À acheter",
      "mpPickReceipt": "Choisissez un de vos tickets enregistrés",
      "mpNoReceipts": "Vous n'avez pas encore de tickets enregistrés.",
      "mpTickItems": "Cochez les articles à ajouter à Mes produits",
      "mpAddSelected": "Ajouter la sélection",
      "mpPickOne": "Sélectionnez au moins un article.",
      "mpFromReceiptDone": "{{added}} ajouté(s) · {{skipped}} déjà présent(s)",
      "itemsCount": "{{count}} article(s)",
      "status_have": "J'en ai assez",
      "status_low": "Bientôt épuisé",
      "status_need": "À acheter",
      "slSignIn": "Connectez-vous pour conserver votre liste de courses privée.",
      "slAddTitle": "Ajouter à la liste de courses",
      "slNamePh": "Saisissez un article, ex. Pain",
      "slNameRequired": "Veuillez saisir un article.",
      "slIncreased": "Quantité augmentée sur votre liste.",
      "slAdded": "Ajouté à votre liste de courses.",
      "slFromProductsHint": "Astuce : touchez \"À acheter\" sur un produit dans Mes produits pour l'ajouter ici.",
      "slEmpty": "Votre liste de courses est vide.",
      "slTick": "Marquer comme acheté",
      "slUntick": "Remettre dans la liste",
      "slBought": "Achetés ({{n}})",
      "slClearCompleted": "Effacer les terminés",
      "slCleared": "{{n}} article(s) effacé(s).",
      "buyAgain": "Racheter",
      "buyAgainDone": "Ajouté à votre liste de courses.",
      "addToMyProductsTitle": "Ajouter à Mes produits ?",
      "addToMyProductsBtn": "Ajouter la sélection à Mes produits",
      "addedToMyProducts": "Ajouté à Mes produits.",
      "cmpButton": "Comparer mes courses",
      "cmpTitle": "Comparer mes courses",
      "cmpOneShop": "Un magasin",
      "cmpTwoShops": "Deux magasins",
      "cmpCheapest": "Le moins cher",
      "cmpNearest": "Le plus proche",
      "cmpEstTotal": "Total estimé",
      "cmpSaving": "Économie estimée",
      "cmpSubtotal": "Sous-total",
      "cmpCoverage": "Prix trouvés pour {{found}} sur {{total}} articles.",
      "cmpNoRecent": "Aucune comparaison récente disponible",
      "cmpNoData": "Aucun prix disponible pour cette option pour l'instant.",
      "cmpDisclaimer": "Estimé à partir des prix des tickets de la communauté. Les prix peuvent avoir changé."
    },
    "notes": {
      "back": "Notes", "overviewHint": "Notes privées et partagées pour cet agenda.",
      "createNote": "Créer une note", "editNote": "Modifier la note", "title": "Titre", "text": "Texte",
      "textPlaceholder": "Écrivez votre note ici …", "colour": "Couleur", "privacy": "Confidentialité",
      "private": "Privée", "shared": "Partagée", "privateHint": "Vous seul pouvez voir cette note.",
      "sharedHint": "Après l'enregistrement, choisissez les membres de l'agenda avec qui la partager.",
      "formHint": "Donnez un titre et un texte à votre note. Les notes sont privées sauf si vous les partagez.",
      "save": "Enregistrer", "cancel": "Annuler", "open": "Ouvrir", "edit": "Modifier", "delete": "Supprimer",
      "copy": "Copier le texte", "share": "Partager", "manageSharing": "Gérer le partage",
      "memberEmail": "E-mail du membre",
      "shareDialogHint": "Saisissez l'e-mail exact d'un membre de l'agenda. Il doit déjà appartenir à cet agenda.",
      "noneShared": "Partagée avec personne pour l'instant.", "sharedWith": "Partagée avec", "sharedTag": "partagée avec vous",
      "readOnly": "Vous avez un accès en lecture seule à cette note.", "empty": "Cette note n'a pas encore de texte.",
      "emptyTitle": "Aucune note pour l'instant", "emptyHint": "Créez votre première note privée ou partagée.",
      "deleteNote": "Supprimer la note",
      "deleteConfirm": "Cela supprime définitivement la note. Cette action est irréversible.",
      "created": "Note créée", "updated": "Note mise à jour", "deleted": "Note supprimée",
      "copied": "Note copiée dans le presse-papiers",
      "shareCopied": "Partage impossible ici – note copiée à la place", "shareSaved": "Partage mis à jour",
      "loadError": "Impossible de charger les notes", "openError": "Cette note n'est pas disponible",
      "saveError": "Impossible d'enregistrer la note", "deleteError": "Impossible de supprimer la note",
      "copyError": "Impossible de copier la note", "shareError": "Impossible de partager la note",
      "shareUpdateError": "Impossible de mettre à jour le partage",
      "dragHandle": "Glisser pour réordonner", "reorderHint": "Glissez une note par sa poignée pour la réordonner, ou utilisez les flèches ▲ ▼",
      "moveUp": "Monter", "moveDown": "Descendre", "reorderError": "Impossible de réordonner"
    },
    "lists": {
      "back": "Listes", "overviewHint": "Listes privées et partagées pour cet agenda.",
      "createList": "Créer une liste", "editList": "Modifier la liste", "name": "Nom", "colour": "Couleur",
      "privacy": "Confidentialité", "private": "Privée", "shared": "Partagée",
      "privateHint": "Vous seul pouvez voir et gérer cette liste.",
      "sharedHint": "Vous choisissez précisément quels membres de l'agenda peuvent y accéder.",
      "formHint": "Nommez votre liste, choisissez une couleur et définissez qui peut la voir.",
      "save": "Enregistrer", "cancel": "Annuler", "delete": "Supprimer", "duplicate": "Dupliquer",
      "editItem": "Modifier l'élément", "deleteList": "Supprimer la liste",
      "deleteConfirm": "Cela supprime définitivement la liste et tous ses éléments. Cette action est irréversible.",
      "manageSharing": "Gérer le partage", "memberEmail": "E-mail du membre",
      "shareHint": "Saisissez l'e-mail exact d'un membre de l'agenda. Il doit déjà appartenir à cet agenda.",
      "noneShared": "Partagée avec personne pour l'instant.", "sharedWith": "Partagée avec", "sharedTag": "partagée avec vous",
      "readOnly": "Vous avez un accès en lecture seule à cette liste.", "noItems": "Aucun élément pour l'instant.",
      "newItem": "Nouvel élément", "itemText": "Élément", "itemPlaceholder": "ex. Lait",
      "quantity": "Quantité", "qty": "Qté", "done": "fait", "emptyTitle": "Aucune liste pour l'instant",
      "emptyHint": "Créez votre première liste privée ou partagée.", "dragHandle": "Glisser pour réordonner",
      "reorderHint": "Glissez la poignée pour réordonner, ou utilisez les flèches ▲ ▼", "reorderListsHint": "Glissez une liste par sa poignée pour la réordonner",
      "itemTextRequired": "Le texte de l'élément est requis", "created": "Liste créée", "updated": "Liste mise à jour",
      "deleted": "Liste supprimée", "duplicated": "Une copie privée a été créée", "itemUpdated": "Élément mis à jour",
      "loadError": "Impossible de charger les listes", "openError": "Cette liste n'est pas disponible",
      "saveError": "Impossible d'enregistrer la liste", "deleteError": "Impossible de supprimer la liste",
      "dupError": "Impossible de dupliquer la liste", "itemError": "Impossible d'ajouter l'élément",
      "itemError2": "Impossible de mettre à jour l'élément", "itemDelError": "Impossible de supprimer l'élément",
      "reorderError": "Impossible de réordonner", "shareSaved": "Partage mis à jour",
      "shareError": "Impossible de mettre à jour le partage"
    },
    "bookingCal": {
      "pickDate": "Choisir une date",
      "repeat": "Répéter", "repeatEditHint": "modifier la répétition de cette réservation",
      "repeatNone": "Ne se répète pas", "repeatDaily": "Chaque jour", "repeatWeekly": "Chaque semaine",
      "repeatBiweekly": "Toutes les 2 semaines", "repeatMonthly": "Chaque mois", "repeatCustom": "Personnalisé",
      "endDateRequired": "Veuillez choisir une date de fin pour la répétition",
      "repeatUpdated": "Répétition mise à jour – {n} réservations", "repeatRemoved": "Cette réservation ne se répète plus",
      "savedEdit": "Réservation mise à jour", "savedDupGroup": "Toutes les réservations dupliquées ont été mises à jour",
      "deleted": "Réservation déplacée vers la corbeille", "skipDate": "Ignorer cette date",
      "skipDateQ": "Ignorer cette date ?",
      "skipDateDesc": "Seule la date {date} sera supprimée. Le reste de la série se répétant reste inchangé. Vous pourrez la restaurer plus tard depuis la corbeille.",
      "dateSkipped": "Cette date a été ignorée – le reste de la répétition reste inchangé",
      "repeatsPrefix": "Se répète", "recEveryDay": "chaque jour", "recEveryNDays": "tous les {n} jours",
      "recEveryWeek": "chaque semaine", "recEvery2Weeks": "toutes les 2 semaines", "recEveryNWeeks": "toutes les {n} semaines",
      "recOn": "le", "recMonthly": "chaque mois", "recEveryNMonths": "tous les {n} mois", "recUntil": "jusqu'au {d}",
      "recForN": "pour {n} occurrences", "repeats": "Réservation récurrente", "repeatsShort": "Se répète",
      "dupDelTitle": "Supprimer la réservation dupliquée",
      "dupDelIntro": "Cette réservation fait partie de {n} créées ensemble via Dupliquer.",
      "dupDelThis": "Supprimer uniquement cette réservation", "dupDelAll": "Supprimer toutes les réservations dupliquées",
      "dupDelAllGo": "Tout supprimer", "dupDelSelect": "Sélectionner les réservations à supprimer",
      "dupDelSelectedGo": "Supprimer la sélection",
      "dupDelAllConfirm": "Supprimer les {n} réservations dupliquées ? Elles seront déplacées vers la corbeille.",
      "dupDelPickOne": "Veuillez sélectionner au moins une réservation.", "dupDelDone": "{n} réservation(s) supprimée(s)",
      "dupDelPartial": "{ok} supprimée(s) ; {fail} échec(s)",
      "dupDelFailed": "Impossible de supprimer les réservations dupliquées",
      "listsNav": "Listes", "notesNav": "Notes"
    },
    "eventCreateFailed": "Impossible de créer l'événement. Veuillez réessayer.",
    "eventUpdateFailed": "Impossible de mettre à jour l'événement. Veuillez réessayer.",
    "eventsBlockedTrialEnded": "Votre période d'essai est terminée. Ajoutez un moyen de paiement pour publier à nouveau des événements.",
    "eventsBlockedPlan": "Votre formule actuelle n'inclut pas les événements. Passez à une formule supérieure pour publier des événements.",
    "eventsBlockedMax": "Vous avez atteint votre limite de {{max}} événements actifs. Archivez un événement ci-dessous ou passez à Featured pour en avoir plus.",
    "eventsActiveHint": "Actifs = uniquement les événements en cours et à venir. Les événements passés/expirés ne comptent pas dans votre limite.",
    "home": {
      "heroTagline": "Tout ce qui se passe dans votre ville.",
      "startCardTitle": "Commencer",
      "startCardDesc": "Découvrez tout ce qui se passe dans votre ville.",
      "businessCardTitle": "Entreprises",
      "businessCardDesc": "Faites la promotion de votre commerce, association ou groupe communautaire.",
      "discoverTitle": "Découvrir commerces & événements",
      "localAlertsTitle": "Centre de sécurité communautaire",
      "classifiedsTitle": "Vendre · Perdus · Trouvés",
      "bankHolidaysTitle": "Jours fériés",
      "emergencyTitle": "Numéros d'urgence",
      "businessSignInTitle": "Vous avez déjà un compte professionnel ? Connectez-vous",
      "businessCalendarTitle": "Calendrier professionnel"
    },
    "frontpage": {
      "claimExistingBusinessTitle": "Revendiquer ou ajouter un commerce",
      "charityApplyTitle": "Fiche communautaire / caritative"
    },
    "frontpageEarnCommission": "Devenir partenaire communautaire",
    "dismiss": "Fermer",
    "safetyOptInTitle": "Ne manquez aucune alerte de sécurité",
    "safetyOptInBody": "Recevez les alertes de sécurité officielles directement sur votre téléphone pour ne jamais manquer d'informations importantes de votre communauté.",
    "safetyOptInCta": "Activer les alertes sur le téléphone",
    "safetyOptInEnabling": "Activation…",
    "safetyOptInError": "Impossible d'activer les alertes. Veuillez réessayer.",
    "appTitle": "Find-2-day",
    "appBadgeTitle": "Alertes sur votre téléphone",
    "appBadgeDesc": "Affiche une pastille sur l'icône de l'app et une notification lorsqu'une nouvelle alerte de sécurité arrive, même quand l'app est fermée.",
    "appBadgeUnsupported": "Non pris en charge sur cet appareil",
    "appBadgeEnabled": "Alertes téléphone activées. Installez Find-2-Day sur votre écran d'accueil pour la pastille d'icône.",
    "appBadgeFallback": "Votre appareil affiche les notifications mais pas la pastille d'icône — vous aurez toujours l'indicateur cloche dans l'app.",
    "appTagline": "Trouvez des commerces, expériences, événements et activités près de chez vous",
    "getStarted": "Commencer",
    "listYourBusiness": "Inscrire votre commerce",
    "signIn": "Se connecter",
    "joinBusiness": "Rejoindre en tant que commerce",
    "categories": {
      "food": "Restauration",
      "music": "Musique & Vie nocturne",
      "family": "Activités familiales",
      "offers": "Offres spéciales",
      "wellbeing": "Bien-être & plus"
    },
    "nav": {
      "discover": "Découvrir",
      "favorites": "Favoris",
      "events": "Événements",
      "offers": "Offres",
      "profile": "Profil",
      "forSale": "Vendre / Perdus / Trouvés",
      "communityHub": "Communauté"
    },
    "welcomeBack": "Bon retour !",
    "signInSubtitle": "Connectez-vous pour continuer",
    "emailOrUsername": "E-mail",
    "password": "Mot de passe",
    "rememberMe": "Se souvenir de moi",
    "forgotPassword": "Mot de passe oublié ?",
    "forgotPasswordTitle": "Mot de passe oublié ?",
    "forgotPasswordDesc": "Entrez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.",
    "forgotPasswordError": "Une erreur s'est produite. Veuillez réessayer.",
    "sendResetLink": "Envoyer le lien",
    "sending": "Envoi...",
    "checkYourEmail": "Vérifiez votre e-mail",
    "resetEmailSent": "Si un compte existe, nous avons envoyé un lien de réinitialisation. Vérifiez votre boîte de réception.",
    "backToSignIn": "Retour à la connexion",
    "setNewPassword": "Définir un nouveau mot de passe",
    "setNewPasswordDesc": "Choisissez un mot de passe fort d'au moins 6 caractères.",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "resetPassword": "Réinitialiser",
    "resetting": "Réinitialisation...",
    "passwordReset": "Mot de passe réinitialisé",
    "passwordResetSuccess": "Votre mot de passe a été réinitialisé avec succès.",
    "invalidResetLink": "Lien invalide",
    "invalidResetLinkDesc": "Ce lien est invalide ou a expiré.",
    "requestNewLink": "Demander un nouveau lien",
    "passwordMinLength": "Le mot de passe doit contenir au moins 6 caractères",
    "passwordsMustMatch": "Les mots de passe ne correspondent pas",
    "emailAddress": "Adresse e-mail",
    "dontHaveAccount": "Pas encore de compte ?",
    "signUp": "S'inscrire",
    "businessSignUp": "Inscription commerce",
    "joinAsBusinessTitle": "Rejoindre en tant que commerce",
    "freeTrialOffer": "Démarrez votre fiche instantanément",
    "accountInformation": "Informations du compte",
    "fullName": "Nom complet",
    "email": "E-mail",
    "businessInformation": "Informations du commerce",
    "businessName": "Nom du commerce",
    "description": "Description",
    "tellUsAbout": "Parlez-nous de votre commerce...",
    "continue": "Continuer",
    "fullNamePlaceholder": "Jean Dupont",
    "passwordPlaceholder": "Créez un mot de passe fort",
    "businessNamePlaceholder": "Nom de votre commerce",
    "stepOf": "Étape {{step}} sur {{total}}",
    "allFieldsRequired": "Tous les champs sont requis",
    "businessNameDescRequired": "Le nom et la description sont requis",
    "fillAllRequired": "Veuillez remplir tous les champs obligatoires",
    "specifyCategoryOther": "Veuillez préciser la catégorie",
    "selectPlanRequired": "Veuillez choisir un plan",
    "registrationFailed": "Échec de l'inscription. Veuillez réessayer.",
    "emailAlreadyRegistered": "Cet e-mail est déjà enregistré.",
    "contactLocation": "Contact & Localisation",
    "categoryLabel": "Catégorie",
    "selectCategory": "Choisir une catégorie",
    "specifyCategory": "Préciser la catégorie",
    "cityLabel": "Ville",
    "businessAddress": "Adresse du commerce",
    "phoneNumber": "Numéro de téléphone",
    "businessEmailLabel": "E-mail du commerce",
    "websiteLabel": "Site web",
    "openingHoursLabel": "Horaires d'ouverture",
    "chooseYourPlan": "Choisissez votre plan",
    "perMonth": "mois",
    "plusIVA": "TVA incluse",
    "bestValue": "Meilleur rapport qualité-prix",
    "selected": "Sélectionné",
    "freeTrialTitle": "Fiche immédiate",
    "freeTrialDesc": "Payez une fois — votre fiche est publiée dès que le paiement est confirmé. Tous les prix TTC (TVA 21% incluse). Annulable à tout moment.",
    "settingUp": "Configuration...",
    "proceedToPayment": "Procéder au paiement",
    "alreadyHaveAccount": "Déjà un compte ?",
    "timeTo": "à",
    "closed": "Fermé",
    "dayMonday": "Lundi",
    "dayTuesday": "Mardi",
    "dayWednesday": "Mercredi",
    "dayThursday": "Jeudi",
    "dayFriday": "Vendredi",
    "daySaturday": "Samedi",
    "daySunday": "Dimanche",
    "plan6months": "6 mois",
    "plan12months": "Best Setup / Accès Complet",
    "featured": "En vedette",
    "searchPlaceholder": "Rechercher des commerces...",
    "logout": "Déconnexion",
    "all": "Tout",
    "pendingTab": "En attente",
    "callNow": "Appeler",
    "emailButton": "E-mail",
    "openingHours": "Horaires d'ouverture",
    "pendingApprovalTitle": "En attente d'approbation",
    "pendingApprovalDesc": "Votre commerce est en cours d'examen",
    "trialDaysRemaining": "{{days}} jour(s) restant(s)",
    "businessVisible": "Votre commerce est visible",
    "subscriptionActive": "Abonnement actif",
    "subscriptionExpired": "Abonnement expiré",
    "activeFilters": "Filtres actifs",
    "noBusinessesFound": "Aucun commerce trouvé.",
    "tryDifferentFilters": "Essayez d'autres filtres ou termes de recherche.",
    "clearFilters": "Effacer les filtres",
    "businessFound": "Commerce trouvé",
    "businessesFound": "Commerces trouvés",
    "filters": "Filtres",
    "resetAll": "Tout réinitialiser",
    "applyFilters": "Appliquer les filtres",
    "settings": "Paramètres",
    "language": "Langue",
    "notifications": "Notifications",
    "noEventsYet": "Pas encore d'événements",
    "browseBusinesses": "Parcourir les commerces",
    "noOffersYet": "Pas encore d'offres",
    "noFavoritesYet": "Pas encore de favoris",
    "discoverBusinesses": "Découvrir les commerces",
    "save": "Enregistrer",
    "saved": "Enregistré",
    "cancel": "Annuler",
    "consentText": "J'accepte les",
    "consentAnd": "et",
    "termsAndConditions": "Conditions générales",
    "privacyPolicyTitle": "Politique de confidentialité",
    "back": "Retour",
    "submit": "Soumettre",
    "or": "ou",
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "goBack": "Retour",
    "goHome": "Accueil",
    "about": "À propos",
    "share": "Partager",
    "copyLink": "Copier le lien",
    "linkCopied": "Copié !",
    "shareMore": "Plus",
    "shareDefaultText": "Découvrez cette annonce sur Find-2-Day !",
    "reviews": "Avis",
    "writeReview": "Écrire un avis",
    "noReviewsYet": "Pas encore d'avis. Soyez le premier !",
    "loginToReview": "Connectez-vous pour laisser un avis",
    "favourite": "Enregistrer",
    "favourited": "Enregistré",
    "resetFilters": "Réinitialiser les filtres",
    "offers": "Offres",
    "activeOffers": "offres actives",
    "upcomingEvents": "événements à venir",
    "daysLeft": "jours restants",
    "manageSubscription": "Gérer l'abonnement",
    "onboardingTitle": "Bienvenue sur Find-2-Day !",
    "onboardingStep1Title": "Découvrir les annonces locales",
    "onboardingStep1Desc": "Parcourez les commerces, associations, événements et offres près de chez vous.",
    "onboardingStep2Title": "Enregistrer vos favoris",
    "onboardingStep2Desc": "Appuyez sur le cœur pour sauvegarder les annonces.",
    "onboardingStep3Title": "Recevoir des notifications",
    "onboardingStep3Desc": "Appuyez sur 'Notifications' pour recevoir les mises à jour.",
    "onboardingGotIt": "Compris !",
    "onboardingNext": "Suivant",
    "onboardingSkip": "Passer",
    "locationPicker": {
      "title": "Recevez les alertes de votre zone",
      "intro": "Choisissez votre commune d'Almería pour recevoir les événements, offres et alertes de sécurité à proximité.",
      "homeTownLabel": "Votre commune ou village",
      "searchPlaceholder": "Rechercher des communes d'Almería…",
      "noTowns": "Aucune commune ne correspond.",
      "nearbyLabel": "Alertez-moi aussi pour les communes proches",
      "nearbyHint": "Dans un rayon de {{km}} km. Ajustez selon vos besoins.",
      "radiusAria": "Rayon en kilomètres",
      "regionLabel": "Toute la province d'Almería",
      "regionHint": "Événements provinciaux, grosses offres et alertes de sécurité.",
      "followedTownsLabel": "Suivre aussi ces communes (optionnel)",
      "followedTownsHint": "Sélectionnez d'autres communes en plus de la vôtre.",
      "followedTownsAddPlaceholder": "Ajouter une commune…",
      "removeTown": "Retirer",
      "skip": "Plus tard",
      "save": "Enregistrer ma zone",
      "saving": "Enregistrement…"
    },
    "categoryFood": "Restauration",
    "categoryMusic": "Musique & Nachtleven",
    "categoryShopping": "Shopping",
    "categoryHealthWellness": "Santé & Bien-être",
    "categoryEvents": "Événements & Divertissement",
    "categoryEducation": "Éducation",
    "categoryHomeServices": "Services à domicile",
    "categoryTravel": "Voyages & Tourisme",
    "categoryBeautySpa": "Beauté & Spa",
    "categorySports": "Sports & Fitness",
    "categoryArts": "Arts & Culture",
    "categoryProfessional": "Services professionnels",
    "categoryAutomotive": "Automobile",
    "categoryTechnology": "Technologie",
    "categoryVets": "Vétérinaires",
    "categoryVolunteerWork": "Bénévolat",
    "categoryJobs": "Emplois",
    "categoryCommunityHelp": "Aide communautaire",
    "categoryCommunity": "Communauté",
    "categoryOther": "Autre",
    "pwaInstallTitle": "Installer Find-2-Day",
    "pwaInstallBtn": "Installer",
    "whatsNew_title": "Nouveautés",
    "whatsNew_item1": "Alertes instantanées de vos commerces préférés — événements, offres et plus",
    "whatsNew_item2": "Fonctionne sur tous les appareils — notifications push avec repli par e-mail",
    "whatsNew_cta": "Notifications pour événements & offres",

    "marketplace": {
      "tabSell": "Vendre", "tabWanted": "Recherché", "tabSwap": "Échange", "tabFree": "Gratuit",
      "hintMarketTitle": "Acheter, vendre, échanger ou donner",
      "swapTitle": "SWAP-2-DAY", "swapSubtitle": "Qu'avez-vous ? Contre quoi l'échangeriez-vous ?",
      "swapLabel": "Échange", "orSwap": "OU ÉCHANGE"
    },
    "swap": {
      "moneyNone": "Aucun", "moneyBtoA": "L'offrant paie le propriétaire €{n}", "moneyAtoB": "Le propriétaire paie l'offrant €{n}",
      "ownerProvides": "Le propriétaire fournit", "offererProvides": "L'offrant fournit", "money": "Argent supplémentaire",
      "negotiation": "Négociation d'échange", "youAre": "Vous êtes le/la", "owner": "propriétaire de l'annonce", "offerer": "personne qui fait l'offre",
      "agreed": "ÉCHANGE CONVENU", "agreedAt": "Convenu le", "finalTerms": "Conditions finales convenues", "currentTerms": "Conditions actuelles",
      "confirmed": "confirmé ✓", "notConfirmed": "pas encore", "ownerLabel": "Propriétaire", "offererLabel": "Offrant",
      "iAgree": "J'accepte cet échange", "youConfirmed": "Vous avez confirmé – en attente de l'autre personne",
      "counter": "Contre-offre", "decline": "Refuser", "withdraw": "Retirer mon offre", "cancel": "Annuler cette négociation",
      "history": "Historique des offres", "makeCounter": "Faire une contre-offre", "commaSep": "séparés par des virgules",
      "moneyAmount": "Argent (€)", "moneyDir": "Sens du paiement", "dirNone": "Pas d'argent", "dirBtoA": "L'offrant paie le propriétaire", "dirAtoB": "Le propriétaire paie l'offrant",
      "notePlaceholder": "Note facultative…", "sendCounter": "Envoyer la contre-offre", "backToMarket": "Retour à la Place de marché",
      "loadFail": "Impossible de charger cet échange.", "actionFail": "Échec de l'action.",
      "ownerGives": "Le propriétaire donne", "describeYours": "Décrivez ce que vous donneriez en échange (vous pouvez aussi ajouter de l'argent).",
      "itemsPlaceholder": "ex. Tondeuse, Débroussailleuse (séparés par des virgules)", "sendOffer": "Envoyer l'offre d'échange", "createFail": "Impossible d'envoyer l'offre.",
      "errName": "Veuillez saisir votre nom.", "errEmail": "Veuillez saisir un e-mail valide.", "errItems": "Décrivez au moins un article que vous proposez."
    },
    "classifieds": {
      "listingType": "Type d'annonce", "typeSellOnly": "Vendre uniquement", "typeSwapOnly": "Échanger uniquement", "typeSellOrSwap": "Vendre ou échanger", "typeFree": "Gratuit", "typeWanted": "Recherché",
      "swapWantedTitle": "Que souhaitez-vous en échange ?", "swapAddOwn": "Ajouter le vôtre…", "openToOffers": "Ouvert aux offres",
      "swapPrefsHint": "Ce ne sont que des préférences – d'autres peuvent proposer autre chose.", "sellSwapPriceHint": "Les acheteurs peuvent acheter à ce prix OU faire une offre d'échange.",
      "errSellSwapPrice": "Veuillez saisir un prix de vente pour une annonce « Vendre ou échanger »",
      "buyFor": "Acheter pour", "swapWantedShort": "Échange souhaité", "swapOpenAny": "ouvert aux idées", "otherOffersConsidered": "Autres offres considérées",
      "contactToBuy": "Contacter pour acheter", "makeSwapOffer": "Faire une offre d'échange", "statusSwapped": "Échangé !",
      "swappedNote": "Les annonces échangées sont masquées de la recherche. Votre historique est conservé pour vous.",
      "editTypePrice": "Modifier le type d'annonce / le prix (par ex. vendre aussi cet article)", "editSwapNote": "Les acheteurs verront « €… OU ÉCHANGE » et pourront faire une offre d'échange. Vos photos, description et ID d'annonce restent identiques.",
      "offersReceived": "Offres d'échange reçues", "noOffersYet": "Aucune offre d'échange pour le moment.", "errSave": "Impossible d'enregistrer les modifications.",
      "title": "Vendre / Perdus / Trouvés",
      "sellTab": "Vendre",
      "hintCardTitle": "Où dois-je publier ceci ?",
      "hintCardSell": "Vendre un article",
      "hintCardSellDesc": "Utilisez l'onglet Vendre",
      "hintCardLostFound": "Perdu ou trouvé quelque chose",
      "hintCardLostFoundDesc": "Utilisez l'onglet Perdus & Trouvés",
      "hintCardPetSafety": "Animal perdu ou problème de sécurité",
      "hintCardPetSafetyDesc": "Utilisez le Centre de sécurité communautaire",
      "searchPlaceholder": "Rechercher des articles...",
      "postItem": "Publier une annonce",
      "noItems": "Aucun article trouvé",
      "tryDifferent": "Essayez d'autres termes de recherche ou filtres",
      "beFirst": "Soyez le premier à publier quelque chose !",
      "itemFound": "article",
      "itemsFound": "articles",
      "negotiable": "Négociable",
      "sold": "Vendu",
      "description": "Description",
      "contactSeller": "Contacter le vendeur",
      "expiresOn": "Cette annonce expire le",
      "ownerActions": "Vous avez accès propriétaire à cette annonce.",
      "markSold": "Marquer comme vendu",
      "delete": "Supprimer",
      "deleteListing": "Supprimer l'annonce",
      "confirmSold": "Marquer comme vendu ?",
      "confirmDelete": "Supprimer l'annonce ?",
      "confirmDeleteDesc": "L'annonce sera définitivement supprimée.",
      "yesSold": "Oui, vendu",
      "yesDelete": "Oui, supprimer",
      "posted": "Annonce publiée !",
      "postedDesc": "Votre annonce est maintenant en ligne. Elle expire automatiquement après 30 jours.",
      "saveLink": "Conservez ce lien pour gérer votre annonce :",
      "viewListing": "Voir l'annonce",
      "browseMore": "Parcourir plus",
      "photos": "Photos",
      "itemTitle": "Titre",
      "titlePlaceholder": "Que vendez-vous ?",
      "category": "Catégorie",
      "price": "Prix",
      "optional": "optionnel",
      "priceHint": "Laissez vide pour \"Négociable\"",
      "descLabel": "Description",
      "descPlaceholder": "Décrivez l'article, état, caractéristiques...",
      "location": "Localisation",
      "locationPlaceholder": "ex. Almería Centro, Retamar...",
      "contactInfo": "Vos coordonnées",
      "yourName": "Nom",
      "namePlaceholder": "Votre nom",
      "yourEmail": "E-mail",
      "emailPlaceholder": "votre@email.fr",
      "yourPhone": "Téléphone",
      "addPhoto": "Ajouter",
      "maxPhotos": "Maximum 6 photos autorisées",
      "posting": "Publication...",
      "postForFree": "Publier gratuitement",
      "autoExpire": "Les annonces expirent automatiquement après 30 jours",
      "cat": {
        "Tools": "Outils",
        "Furniture": "Meubles",
        "Cars & Vehicles": "Voitures & Véhicules",
        "Electronics": "Électronique",
        "Property": "Immobilier",
        "Clothing & Fashion": "Vêtements & Mode",
        "Home & Garden": "Maison & Jardin",
        "Sports & Leisure": "Sports & Loisirs",
        "Baby & Kids": "Bébé & Enfants",
        "General": "Général"
      },
      "statusAvailable": "Disponible",
      "statusPending": "En attente de collecte",
      "statusSold": "Vendu",
      "changeStatus": "Changer le statut",
      "soldAutoRemove": "Les articles vendus sont masqués et supprimés après 3 jours.",
      "errorStatus": "Impossible de mettre à jour le statut.",
      "emailSent": "Lien de gestion envoyé à votre e-mail",
      "emailSentDesc": "Vérifiez votre boîte de réception pour le lien de modification ou suppression.",
      "manageHelp": "Avec votre lien de gestion, vous pouvez :",
      "manageEdit": "Modifier les détails de l'annonce",
      "managePending": "Définir le statut sur 'En attente de collecte'",
      "manageSold": "Marquer comme Vendu (masqué après 3 jours)",
      "manageDelete": "Supprimer l'annonce",
      "manageListing": "Gérer l'annonce",
      "manageYourListing": "Gérer votre annonce",
      "resendLink": "Lien de gestion perdu ?",
      "resendTitle": "Récupérer vos liens de gestion",
      "resendDesc": "Entrez l'e-mail utilisé lors de la publication.",
      "resendEmailPlaceholder": "votre@email.fr",
      "resendBtn": "Envoyer",
      "resendSent": "Vérifiez votre e-mail !",
      "resendSentDesc": "Si des annonces actives existent, nous avons envoyé les liens de gestion.",
      "resendErrEmail": "Veuillez entrer un e-mail valide",
      "resendError": "Une erreur s'est produite. Réessayez."
    },
    "nearestMe": {
      "button": "Près de moi",
      "notSupported": "La géolocalisation n'est pas supportée par votre navigateur",
      "denied": "Accès à la localisation refusé. Vous pouvez chercher par ville.",
      "error": "Impossible d'obtenir votre position. Réessayez.",
      "townPlaceholder": "Saisissez une ville, ex. Lyon, France",
      "useTown": "Utiliser la ville",
      "townNotFound": "Ville introuvable. Essayez une plus grande ville proche ou ajoutez le pays."
    },
    "lostFound": {
      "title": "Objets trouvés",
      "searchPlaceholder": "Rechercher objets perdus/trouvés...",
      "postItem": "Signaler un objet perdu/trouvé",
      "noItems": "Aucun objet trouvé",
      "beFirst": "Signalez un objet perdu ou trouvé.",
      "lost": "Perdu", "found": "Trouvé", "lostOn": "Perdu", "foundOn": "Trouvé",
      "resolved": "Résolu", "markResolved": "Marquer comme résolu", "contactPerson": "Contact",
      "typeLabel": "L'objet est-il perdu ou trouvé ?",
      "iLostSomething": "J'ai perdu quelque chose", "iFoundSomething": "J'ai trouvé quelque chose",
      "itemTitle": "Qu'avez-vous perdu/trouvé ?",
      "titlePlaceholder": "ex. Petit chien brun, clés de voiture...",
      "category": "Catégorie", "dateLost": "Date de perte", "dateFound": "Date de découverte",
      "descPlaceholder": "Décrivez l'objet, où il a été perdu/trouvé...",
      "locationLabel": "Zone / Lieu", "locationPlaceholder": "ex. Almería Centro, Retamar...",
      "posted": "Publié !", "postedDesc": "Votre annonce est active. Elle expire après 30 jours.",
      "viewItem": "Voir l'objet", "browseMore": "Parcourir plus", "postForFree": "Publier gratuitement",
      "cat": { "Pets": "Animaux", "Keys": "Clés", "Wallets/Bags": "Portefeuilles/Sacs", "Documents/ID": "Documents/Pièce d'identité", "Phones/Electronics": "Téléphones/Électronique", "Other": "Autre" }
    },
    "savedSearch": {
      "setAlert": "Créer une alerte",
      "title": "Alerte de recherche",
      "desc": "Soyez notifié quand de nouveaux articles correspondent à votre recherche.",
      "queryPlaceholder": "ex. canapé, vélo, iPhone...",
      "anyCategory": "Toutes catégories",
      "emailPlaceholder": "Votre e-mail pour les notifications",
      "save": "Enregistrer l'alerte",
      "saving": "Enregistrement...",
      "saved": "Alerte enregistrée !",
      "savedDesc": "Nous vous enverrons un e-mail quand de nouveaux articles correspondent.",
      "errQuery": "Le terme de recherche doit comporter au moins 2 caractères",
      "errEmail": "Veuillez entrer un e-mail valide",
      "errSave": "Échec de l'enregistrement de l'alerte",
      "unsubscribed": "Désabonné",
      "unsubscribedDesc": "Vous ne recevrez plus de notifications pour cette recherche.",
      "unsubscribeError": "Échec du désabonnement",
      "unsubscribeErrorDesc": "Ce lien a peut-être expiré.",
      "backToClassifieds": "Parcourir Vendre / Perdus / Trouvés"
    },

    "legal": "Mentions légales",
    "nearbyDeals": "Offres & Promotions à proximité",
    "nearbyDealsDesc": "Recevez des offres sponsorisées occasionnelles de commerces que vous ne suivez pas",
    "enableNotificationsFirst": "Suivez un commerce ou activez les notifications pour gérer vos préférences.",
    "account": "Compte",
    "support": "Assistance",
    "privacySecurity": "Confidentialité & Sécurité",
    "helpCenter": "Centre d'aide",
    "aboutApp": "À propos de Find-2-Day",
    "termsOfService": "Conditions générales",
    "privacyPolicy": "Politique de confidentialité",
    "cookiePolicy": "Politique de cookies",
    "disputePolicy": "Politique de litiges",
    "admin": "Admin",
    "terms": "Conditions",
    "privacy": "Confidentialité",
    "cookies": "Cookies",
    "deleteData": "Supprimer mes données",
    "deleteAccountTitle": "Supprimer le compte & les données",
    "whatWillBeDeleted": "Ce qui sera supprimé :",
    "deleteItem1": "Votre compte utilisateur et identifiants",
    "deleteItem2": "Fiche d'entreprise et photos (le cas échéant)",
    "deleteItem3": "Favoris et préférences sauvegardées",
    "deleteItem4": "Toutes les données personnelles associées",
    "reasonOptional": "Raison (optionnel)",
    "reasonPlaceholder": "Dites-nous pourquoi vous partez...",
    "requestDeletion": "Demander la suppression du compte",
    "emailDirectly": "Vous pouvez également envoyer votre demande directement à :",
    "requestReceived": "Demande reçue",
    "requestReceivedDesc": "Votre demande de suppression a été soumise. Nous la traiterons sous 30 jours.",
    "contactDirectly": "Vous pouvez aussi nous contacter directement à",
    "changePasswordTitle": "Changer le mot de passe",
    "memberSince": "Membre depuis",
    "businessAccount": "Compte professionnel",
    "regularAccount": "Compte utilisateur",
    "businessDashboard": "Tableau de bord",
    "businessNotFound": "Profil d'entreprise introuvable",
    "listingUnavailable": "Cette fiche d'entreprise n'est plus disponible.",
    "duplicateViewBtn": "Voir la fiche",
    "claimRetiredTitle": "La revendication n'est plus disponible",
    "claimRetiredBody": "Find-2-Day fonctionne désormais par auto-inscription. Si vous avez une entreprise, créez simplement votre propre fiche — inutile de revendiquer une fiche existante.",
    "claimRetiredRegister": "Inscrire votre entreprise",
    "backToHome": "Retour à l'accueil",
    "townCityLabel": "Ville", "townCityPlaceholder": "ex. Madrid", "countryLabel": "Pays", "countrySelect": "Sélectionnez un pays", "regionLabel": "Région / État / Province", "regionPlaceholder": "ex. Andalousie", "localAreaLabel": "Quartier / Secteur", "postcodeLabel": "Code postal", "regionLabel2": "Région / État", "provinceLabel": "Province", "provincePlaceholder": "ex. Almería", "mapView": "Carte", "mapNoCoords": "Aucune de ces entreprises n'a encore de localisation sur la carte. Passez à la vue liste pour voir tous les résultats.", "directionsBtn": "Itinéraire", "filterCountry": "Pays", "filterRegion": "Région / État", "filterProvince": "Province", "filterTown": "Ville", "allCountries": "Tous les pays", "allRegions": "Toutes les régions", "allProvinces": "Toutes les provinces", "allTowns": "Toutes les villes", "locationFilterLabel": "Localisation",
    "faqTitle": "Questions fréquentes",
    "faq1q": "Comment enregistrer mon commerce ?",
    "faq1a": "Cliquez sur 'Rejoindre en tant que commerce' et suivez le processus en 5 étapes.",
    "faq2q": "Comment fonctionne la facturation ?",
    "faq2a": "Tous les plans démarrent immédiatement après le paiement — sans essai gratuit.",
    "faq3q": "Quand mon commerce sera-t-il visible ?",
    "faq3a": "Après approbation par l'administrateur, généralement sous 24-48 heures.",
    "contactUs": "Nous contacter",
    "trialPeriod": "Facturation",
    "subscriptionPlans": "Plans d'abonnement",
    "allRightsReserved": "Tous droits réservés.",
    "aboutDescription": "Find-2-Day est votre plateforme de découverte locale. Trouvez des restaurants, événements, activités et offres près de chez vous.",

    "findAmazing": "Trouvez des expériences incroyables près de chez vous",
    "eventsWillAppear": "Les événements des commerces locaux apparaîtront bientôt ici !",
    "offersWillAppear": "Revenez bientôt pour de superbes offres !",
    "startExploring": "Commencez à explorer les commerces et sauvegardez vos favoris !",

    "changePassword": "Changer le mot de passe",
    "backToHome": "Retour à l'accueil",
    "days": "jours",
    "enableNotifications": "Activer les notifications",
    "notificationSettings": "Paramètres de notification",
    "visitWebsite": "Visiter le site web",
    "featuresAmenities": "Équipements & Services",
    "noFeaturesYet": "Aucune fonctionnalité ou service ajouté.",
    "addFeatures": "Ajouter Fonctionnalités & Services",
    "featureEditHint": "Cliquez sur les éléments pour les ajouter ou supprimer. Enregistrez ensuite.",
    "reviewCount": "avis",
    "reviewBy": "Avis de",
    "ratingRequired": "Veuillez donner une note",
    "reviewTextMin": "Minimum 10 caractères",
    "reviewTextMax": "Maximum 500 caractères",
    "charsRemaining": "caractères restants",
    "submittingReview": "Envoi...",
    "reviewSubmitted": "Avis soumis !",
    "alreadyReviewed": "Vous avez déjà donné un avis",
    "removeFavorite": "Retirer des favoris",
    "reportListing": "Signaler l'annonce",
    "reportReview": "Signaler l'avis",
    "loginToReport": "Connectez-vous pour signaler",
    "loginToClaim": "Connectez-vous pour revendiquer",
    "signInToClaim": "Connectez-vous pour revendiquer",
    "claimThisBusiness": "Revendiquer ce commerce",
    "claimNowBtn": "Revendiquer maintenant",
    "claimBanner": "C'est votre commerce ?",
    "claimTopBannerText": "Revendiquez cette fiche pour la gérer",
    "claimToUnlock": "Revendiquez la fiche pour la gérer",
    "claimSubmitted": "Revendication soumise",
    "claimSubmittedDesc": "Nous examinerons votre demande et vous contacterons.",
    "claimAutoApproved": "Approuvé automatiquement",
    "claimAutoApprovedDesc": "Votre revendication a été approuvée !",
    "claimAlreadyClaimed": "Déjà revendiqué",
    "claimAlreadyPending": "Revendication en cours d'examen",
    "claimStatusApproved": "Approuvé",
    "claimStatusPending": "En cours d'examen",
    "claimStatusRejected": "Rejeté",
    "claimError": "Erreur de revendication",
    "alreadyListedClaim": "Ce commerce est déjà enregistré",
    "unclaimedListing": "Fiche non revendiquée",
    "unclaimedContactNotice": "Les coordonnées peuvent ne pas être à jour",
    "verifiedOwner": "Propriétaire vérifié",
    "verifyingEmail": "Vérification de l'e-mail...",
    "verifySuccessDesc": "Votre e-mail a été vérifié.",
    "resetPasswordError": "Erreur lors de la réinitialisation du mot de passe",
    "token": "Jeton",
    "expirestoday": "Expire aujourd'hui",
    "groupSizesWelcome": "Groupes bienvenus",
    "firstFollowBoost": "Suivez des commerces pour des mises à jour !",
    "followEmptyTitle": "Aucun commerce suivi",
    "followEmptyDesc": "Suivez des commerces pour recevoir des mises à jour",
    "followEmptyCta": "Découvrir les commerces",
    "notifIOSShort": "iOS : Ajouter à l'écran d'accueil",
    "notifAndroidShort": "Android : Installer",
    "notifGenericShort": "Activer les notifications",
    "disputePolicyTitle": "Politique de litiges et signalement",
    "charity.applyForListing": "Postuler pour une fiche communautaire ou caritative gratuite",
    "charity.charityBadge": "Communautaire et caritatif",
    "planBasic": "De base", "perYear": "/an", "per6Months": "/6 mois", "per12Months": "/12 mois",
    "ivaIncluded": "TVA incluse",
    "basicMonthlyHint": "Offre Entreprise Fondatrice · 12 mois GRATUITS — sans carte",
    "basicRestrictions": "Fiche + photos + contact uniquement. Pas d'événements, offres ou promotions boostées.",
    "upgradeFromBasicTitle": "Débloquez événements, offres et fonctionnalités",
    "upgradeFromBasicDesc": "Toutes les entreprises sont actuellement gratuites pendant 12 mois dans le cadre de l'Offre Entreprise Fondatrice — événements, offres, promotions boostées et toutes les fonctionnalités sont incluses sans frais pendant la période fondatrice.",
    "earnUpToPerSignup": "Gagnez jusqu'à 20 € par inscription",
    "minPayoutHint": "{{amount}} € de solde minimum requis pour un paiement.",
    "payoutProgress": "Progression du paiement",
    "balanceLabel": "Solde",
    "eligibleForPayout": "Prêt à être versé",
    "notYetEligible": "Pas encore disponible — continuez !",
    "pendingMaturing": "En attente (maturation)",
    "pendingMaturingDesc": "Commissions en période de maturation de {{days}} jours.",
    "availableForPayout": "Disponible pour versement",
    "availableForPayoutDesc": "Délai de {{days}} jours écoulé et prêt à être versé.",
    "clearanceTooltip": "Les commissions deviennent disponibles {{days}} jours après le paiement, conformément à la fenêtre de contestation de notre processeur de paiement. Vous percevrez le montant total — seulement {{days}} jours de maturation.",
    "maturesInDays": "Mature dans {{count}} jour",
    "maturesInDays_plural": "Mature dans {{count}} jours",
    "availableNow": "Disponible",
    "min": "min",
    "payoutCycleNote": "Les paiements sont examinés après une période de {{days}} jours (fenêtre de remboursement) et traités mensuellement par l'équipe d'administration.",
    "calendar": { "addToCalendar": "Ajouter au calendrier", "icsDownload": "Apple / Outlook (.ics)", "icsHint": "Fichier universel de calendrier", "googleCalendar": "Google Agenda", "googleHint": "S'ouvre dans un nouvel onglet" },
    "previewYourListing": "Aperçu de votre fiche",
    "previewYourListingHint": "Voyez exactement à quoi ressemblera votre fiche avant de payer. S'ouvre dans un nouvel onglet — rien n'est enregistré.",
    "waiverTitle": "Démarrage immédiat du service",
    "waiverLabel": "J'accepte que mon annonce soit publiée immédiatement et je renonce à mon droit de rétractation de 14 jours en vertu du droit de la consommation de l'UE.",
    "waiverRequired": "Vous devez accepter la renonciation au droit de rétractation pour continuer.",
    "waiverLegalNote": "Conformément à la directive UE 2011/83/UE, art. 16 m (contenu numérique / services fournis immédiatement).",
    "emergency": {
      "title": "Numéros d'urgence", "subtitle": "Région d'Almería — appuyez pour appeler",
      "disclaimerTitle": "En cas d'urgence vitale :", "disclaimerBody": "Cette page est informative.",
      "callNow": "appelez le 112 maintenant", "tapToCall": "Appuyez pour appeler",
      "footerNote": "Numéros vérifiés en février 2026.",
      "euEmergency": "Urgence (UE)", "euEmergencyDesc": "Numéro unique pour police, ambulance et pompiers dans l'UE",
      "nationalPolice": "Policía Nacional", "nationalPoliceDesc": "Police nationale — crimes graves",
      "guardiaCivil": "Guardia Civil", "guardiaCivilDesc": "Zones rurales, routes, frontières",
      "localPolice": "Policía Local", "localPoliceDesc": "Incidents locaux, stationnement",
      "medical": "Urgence médicale", "medicalDesc": "Ambulance et santé urgente",
      "fire": "Pompiers", "fireDesc": "Incendies, secours",
      "dvSupport": "Aide violences conjugales", "dvSupportDesc": "Ligne 24/7 gratuite et confidentielle",
      "torrecardenas": "Hôpital Torrecárdenas", "torrecardenasDesc": "Hôpital public principal d'Almería",
      "ukConsulate": "Consulat britannique (Málaga)", "ukConsulateDesc": "Soutien aux citoyens britanniques",
      "ieConsulate": "Ambassade d'Irlande (Madrid)", "ieConsulateDesc": "Soutien aux citoyens irlandais",
      "cat": { "primary": "Urgence", "police": "Police", "medical": "Médical", "fire": "Pompiers", "support": "Aide", "consulate": "Consulat" }
    },
    "holidays": {
      "title": "Jours fériés", "subtitle": "Espagne & Andalousie — 2026",
      "nextHoliday": "Prochain jour férié", "today": "Aujourd'hui", "tomorrow": "Demain", "inNDays": "dans {{count}} jours",
      "footerNote": "Les dates peuvent varier selon la commune.",
      "scope": { "national": "National", "andalusia": "Andalousie", "almeria": "Almería" },
      "month": { "january": "janvier", "february": "février", "march": "mars", "april": "avril", "may": "mai", "june": "juin", "july": "juillet", "august": "août", "september": "septembre", "october": "octobre", "november": "novembre", "december": "décembre" },
      "newYear": "Jour de l'An", "epiphany": "Épiphanie (Rois Mages)", "andalusiaDay": "Jour de l'Andalousie",
      "maundyThursday": "Jeudi Saint", "goodFriday": "Vendredi Saint", "labourDay": "Fête du Travail",
      "sanJuan": "San Juan (Almería)", "assumption": "Assomption", "virgenDelMar": "Virgen del Mar (Almería)",
      "nationalDay": "Fête nationale espagnole", "allSaints": "Toussaint",
      "constitutionDay": "Jour de la Constitution", "immaculate": "Immaculée Conception", "christmas": "Noël"
    },

    // Added Feb 2026 — auth, inbox, data deletion, trial, safety bulletin, guide
    "common": { "back": "Retour", "loading": "Chargement…", "optional": "optionnel" },
    "auth": {
      "pwStrongPlaceholder": "Créez un mot de passe sécurisé",
      "pwReenter": "Ressaisir le mot de passe",
      "pwReenterFull": "Ressaisissez votre mot de passe",
      "pwMin6": "Au moins 6 caractères",
      "pwConfirm": "Confirmer le mot de passe"
    },
    "businessAuth": {
      "loginTitle": "Connexion Entreprise",
      "loginSubtitle": "Connectez-vous pour gérer votre fiche entreprise",
      "signIn": "Se connecter",
      "signingIn": "Connexion en cours…",
      "noAccount": "Pas encore de compte ?",
      "registerHere": "Inscrivez-vous ici",
      "backHome": "Retour à l'accueil",
      "errInvalidType": "Type de compte invalide. Utilisez un compte entreprise.",
      "errLoginFailed": "Échec de la connexion. Veuillez réessayer.",
      "registerTitle": "Inscrivez votre entreprise",
      "step1": "Étape 1 : créez votre compte",
      "step2": "Étape 2 : détails de l'entreprise",
      "phName": "Nom de votre entreprise",
      "phCategory": "Sélectionner une catégorie",
      "phAddress": "Adresse"
    },
    "helperAuth": {
      "loginTitle": "Connexion Partenaire",
      "loginSubtitle": "Connectez-vous pour voir vos parrainages et commissions"
    },
    "inbox": {
      "title": "Notifications",
      "typeEvent": "Événement", "typeOffer": "Offre", "typeSystem": "Système", "typeSafety": "Sécurité",
      "justNow": "à l'instant", "minsAgo": "il y a {{n}} min", "hoursAgo": "il y a {{n}} h", "daysAgo": "il y a {{n}} j",
      "unreadCount": "{{n}} non lues", "sponsoredCount": "{{n}} sponsorisées",
      "settingsTitle": "Paramètres des notifications", "markAllRead": "Tout marquer comme lu",
      "errLoad": "Impossible de charger les notifications", "errMarkAll": "Échec du marquage comme lu",
      "emptyEnableTitle": "Activer les notifications",
      "emptyEnableBody": "Activez les notifications depuis une page d'entreprise ou dans les Paramètres pour recevoir les alertes ici.",
      "openSettings": "Ouvrir les Paramètres",
      "emptyTitle": "Pas encore de notifications",
      "emptyBody": "Lorsque les entreprises que vous suivez publient de nouveaux événements ou offres, ils apparaîtront ici.",
      "sponsored": "Sponsorisé", "sponsoredTitle": "Ceci est une offre promue",
      "unread": "Non lu", "fallbackTitle": "Notification"
    },
    "dataDeletion": {
      "title": "Supprimer votre compte",
      "subtitle": "Cette action est définitive et irréversible.",
      "doneTitle": "Compte supprimé",
      "doneBody": "Votre compte a été supprimé définitivement. Vos avis publics ont été anonymisés. Vous pouvez vous réinscrire à tout moment avec un nouveau compte.",
      "doneSubCancelled": "Votre abonnement actif a été annulé.",
      "doneUnclaimed": "Votre fiche entreprise est revenue à un état non revendiqué pour que la communauté puisse toujours la trouver.",
      "backHome": "Retour à l'accueil",
      "signInRequired": "Connexion requise",
      "signInBody": "Vous devez être connecté pour supprimer votre compte.",
      "goSignIn": "Aller à la connexion",
      "deletedHeading": "Supprimé définitivement",
      "deletedItem1": "Votre compte, e-mail et mot de passe",
      "deletedItem2": "Favoris enregistrés et boîte de notifications",
      "deletedItem3": "Abonnements de notification et liens d'appareil",
      "deletedItem4": "Tous signalements ou demandes de revendication en attente",
      "anonHeading": "Anonymisé (conservé public, sans votre nom)",
      "anonItem1": "Avis que vous avez rédigés — affichés comme 'Utilisateur supprimé'",
      "anonItem2": "Journaux de modération/audit déjà traités",
      "bizHeading": "Si vous possédez une fiche entreprise",
      "bizItem1": "Votre abonnement sera immédiatement annulé via Stripe",
      "bizItem2": "La fiche redeviendra non revendiquée (pour que les habitants puissent la trouver)",
      "bizItem3": "Vous pourrez la revendiquer plus tard avec un nouveau compte",
      "legalHeading": "Conservé pour raisons légales/fiscales",
      "legalItem1": "Factures Stripe (loi fiscale espagnole : 6 ans de conservation)",
      "legalItem2": "Registre de suppression anonymisé (conservé 2 ans)",
      "reasonLabel": "Motif du départ",
      "reasonPlaceholder": "Aidez-nous à nous améliorer — qu'est-ce qui vous a fait partir ?",
      "typeDeleteLead": "Tapez", "typeDeleteTrail": "pour confirmer",
      "deleting": "Suppression…",
      "deletePermanent": "Supprimer mon compte définitivement",
      "cancelKeep": "Annuler, conserver mon compte",
      "errDefault": "Impossible de supprimer le compte. Réessayez ou contactez le support."
    },
    "trial": {
      "signupTitle": "Commencez avec un essai gratuit de 60 jours — sans carte",
      "signupBody": "Essayez Find-2-Day gratuitement pendant 60 jours. Ajoutez un moyen de paiement à tout moment avant le 60ᵉ jour. Si vous n'en ajoutez pas, vos événements et offres seront mis en pause automatiquement — votre fiche reste visible.",
      "signupCta": "Commencer l'essai gratuit de 60 jours — sans carte",
      "includesTrialBadge": "Inclut un essai gratuit de 60 jours — sans carte",
      "instantListingTrialDesc": "Toutes les entreprises sont actuellement gratuites pendant 12 mois dans le cadre de l'Offre Entreprise Fondatrice — sans carte.",
      "bulletReminders": "Nous vous rappellerons 14, 7 et 2 jours avant la fin de l'essai",
      "paymentLabel": "Essai gratuit", "pausedLabel": "En pause",
      "feedbackPrompt": "Pouvez-vous nous dire pourquoi ? Cela nous aide à améliorer.",
      "feedbackThanks": "Merci — c'est précieux.",
      "feedbackSend": "Envoyer",
      "feedbackError": "Impossible d'envoyer le feedback pour le moment.",
      "feedbackNotePlaceholder": "Voulez-vous ajouter quelque chose (facultatif)",
      "reasonNotReady": "Pas encore prêt",
      "reasonPriceTooHigh": "Prix trop élevé",
      "reasonPreferMonthly": "Préfère payer mensuellement",
      "reasonOther": "Autre"
    },
    "safety": {
      "title": "Centre de sécurité communautaire",
      "subtitle": "Mises à jour officielles d'urgence, signalements communautaires et aide locale pendant les incidents.",
      "disclaimer": "Pas un service de police. En cas d'urgence, appelez le 112. Les publications sont vérifiées par notre équipe avant publication. Pas de noms, pas d'accusations, pas de plaques d'immatriculation, pas d'informations privées.",
      "empty": "Pas encore d'alertes pour ce filtre.",
      "submitCta": "+ Soumettre une alerte",
      "myPosts": "Mes soumissions",
      "verifiedResident": "Résident(e) vérifié(e) de {{town}}",
      "publishedOn": "Publié le {{date}}",
      "allTowns": "Toutes les villes", "allCategories": "Toutes les catégories",
      "category": {
        "incident_factual": "Incident (factuel)",
        "safety_tip": "Conseil de sécurité",
        "lost_pet": "Animal perdu",
        "community_alert": "Alerte communautaire"
      },
      "report": {
        "button": "Signaler",
        "title": "Signaler cette alerte",
        "placeholder": "Pourquoi cette alerte pose-t-elle problème ?",
        "submit": "Envoyer le signalement",
        "thanks": "Merci — nous allons l'examiner.",
        "alreadyReported": "Vous avez déjà signalé cette alerte."
      },
      "filterTown": "Filtrer par ville",
      "filterCategory": "Catégorie",
      "categoryHint": {
        "incident_factual": "Une note courte et factuelle. Pas de noms, pas d'accusations.",
        "safety_tip": "Un conseil général qui aide les voisins à rester en sécurité.",
        "lost_pet": "Animal disparu. Décrivez l'animal, le dernier endroit vu et utilisez la plateforme pour le contact — pas d'adresses personnelles.",
        "community_alert": "Alerte éphémère (supprimée automatiquement après 24 h)."
      },
      "expiresIn": "Visible pendant {{value}}",
      "submit": {
        "title": "Soumettre une alerte de sécurité",
        "intro": "Partagez une note courte et factuelle avec des voisins vérifiés de votre ville. Chaque publication est examinée par notre équipe avant publication.",
        "town": "Ville (province d'Almería uniquement)",
        "townPlaceholder": "Sélectionnez votre ville",
        "categoryLabel": "De quel type de publication s'agit-il ?",
        "titleLabel": "Titre",
        "titlePlaceholder": "Résumé court (80 caractères max)",
        "bodyLabel": "Détails",
        "bodyPlaceholder": "Texte brut uniquement. Pas de liens, pas de noms, pas d'accusations, pas de plaques, pas d'infos privées. Max 500 caractères.",
        "rules": "En soumettant, je confirme :",
        "rulesNoNames": "Je n'ai nommé personne.",
        "rulesNoAccusations": "Je n'accuse personne d'un délit.",
        "rulesNoPlates": "Je n'ai pas inclus de plaque d'immatriculation.",
        "rulesNoPrivate": "Je n'ai pas inclus d'adresse, numéro de téléphone ou autre info privée.",
        "confirmCheckbox": "Je confirme : pas de noms, pas d'accusations, pas de plaques, pas d'infos privées.",
        "submitButton": "Soumettre pour examen",
        "needTown": "Sélectionnez une commune",
        "needTitle": "Ajoutez un titre (au moins 4 caractères)",
        "needBody": "Ajoutez des détails (au moins 10 caractères)",
        "needConfirm": "Cochez la case de confirmation",
        "submitting": "Envoi en cours…",
        "successTitle": "Soumis — en attente d'examen",
        "successBody": "Notre équipe examinera votre publication. Vous recevrez un e-mail à l'approbation ou si des modifications sont nécessaires.",
        "characters": "{{count}} caractères",
        "loginRequired": "Veuillez vous connecter pour soumettre une alerte.",
        "signIn": "Se connecter",
        "rateLimitHit": "Limite atteinte — vous pouvez soumettre jusqu'à 3 alertes par 24 h."
      },
      "mine": {
        "empty": "Vous n'avez encore soumis aucune alerte.",
        "status": {
          "pending": "En attente d'examen",
          "approved": "Publié",
          "rejected": "Non publié",
          "expired": "Expiré",
          "takedown": "Retiré"
        },
        "rejectionReason": "Motif : {{reason}}",
        "back": "Retour à l'alerte",
        "markFound": "Marquer comme retrouvé",
        "markFoundSuccess": "Marqué comme retrouvé — merci de nous avoir prévenus !",
        "markFoundFailed": "Impossible de marquer comme retrouvé.",
        "closedFound": "Clôturé — animal retrouvé",
        "edit": "Modifier",
        "editHeading": "Modifier l'alerte",
        "editTown": "Commune",
        "editCategory": "Catégorie",
        "editTitleField": "Titre",
        "editBody": "Détails",
        "editPendingNote": "Modifier une alerte publiée la renvoie en examen avant qu'elle ne soit à nouveau publiée.",
        "editCancel": "Annuler",
        "editSave": "Enregistrer les modifications",
        "editSuccessPending": "Enregistré — votre alerte est de nouveau en examen et sera publiée une fois approuvée.",
        "editSuccessLive": "Votre alerte a été mise à jour.",
        "editFailed": "Impossible d'enregistrer les modifications. Veuillez réessayer.",
        "editLiveNote": "Votre modification reste publiée immédiatement — les abonnés ne sont notifiés que si vous le choisissez ci-dessous.",
        "editNotifyFollowers": "Notifier les abonnés de cette mise à jour",
        "editSuccessNotified": "Enregistré — vos abonnés ont été notifiés de la mise à jour."
      }
    },
    "guideSubInstant": "Votre fiche est en ligne dès que votre abonnement est confirmé (ou instantanément au démarrage d'un essai gratuit de 60 jours sur la formule 12 mois).",
    "faq2a": "Toutes les entreprises sont actuellement gratuites pendant 12 mois dans le cadre de l'Offre Entreprise Fondatrice — sans carte, sans paiement pendant la période fondatrice. Les tarifs futurs (s'ils sont introduits) seront communiqués bien à l'avance.",

    // PASS 2 (Feb 2026)
    "emergency": {
      "title": "Numéros d'urgence",
      "subtitle": "Région d'Almería — appuyez sur un numéro pour appeler",
      "disclaimerTitle": "En cas d'urgence vitale :",
      "disclaimerBody": "Cette page est informative et peut ne pas refléter les dernières modifications officielles.",
      "callNow": "appelez le 112 maintenant",
      "tapToCall": "Appuyer pour appeler",
      "footerNote": "Vérifié pour la dernière fois en février 2026. Toujours confirmer les infos critiques auprès des sources officielles.",
      "euEmergency": "Urgence (UE)",
      "euEmergencyDesc": "Numéro unique pour police, ambulance et pompiers dans l'UE",
      "nationalPolice": "Policía Nacional",
      "nationalPoliceDesc": "Police nationale — crimes graves, documents d'identité",
      "guardiaCivil": "Guardia Civil",
      "guardiaCivilDesc": "Zones rurales, routes et frontières",
      "localPolice": "Policía Local",
      "localPoliceDesc": "Incidents locaux, stationnement, questions municipales",
      "medical": "Urgences médicales",
      "medicalDesc": "Ambulance et services de santé urgents",
      "fire": "Pompiers",
      "fireDesc": "Bomberos — incendies, sauvetages, inondations",
      "dvSupport": "Aide aux victimes de violence domestique",
      "dvSupportDesc": "Ligne confidentielle 24/7 (gratuite, n'apparaît pas sur les factures)",
      "torrecardenas": "Hôpital Torrecárdenas",
      "torrecardenasDesc": "Hôpital public principal de la ville d'Almería",
      "ukConsulate": "Consulat du Royaume-Uni (Málaga)",
      "ukConsulateDesc": "Aide aux ressortissants britanniques du sud de l'Espagne",
      "ieConsulate": "Ambassade d'Irlande (Madrid)",
      "ieConsulateDesc": "Aide aux ressortissants irlandais — couvre toute l'Espagne",
      "cat": { "primary": "Urgence", "police": "Police", "medical": "Médical", "fire": "Incendie", "support": "Soutien", "consulate": "Consulat" }
    },
    "holidays": {
      "title": "Jours fériés",
      "subtitle": "Espagne & Andalousie — 2026",
      "nextHoliday": "Prochain jour férié",
      "today": "Aujourd'hui",
      "tomorrow": "Demain",
      "inNDays": "dans {{count}} jours",
      "footerNote": "Les dates peuvent varier selon la municipalité. Vérifiez auprès de votre mairie.",
      "scope": { "national": "National", "andalusia": "Andalousie", "almeria": "Almería" },
      "month": { "january": "Janvier", "february": "Février", "march": "Mars", "april": "Avril", "may": "Mai", "june": "Juin", "july": "Juillet", "august": "Août", "september": "Septembre", "october": "Octobre", "november": "Novembre", "december": "Décembre" },
      "newYear": "Jour de l'An",
      "epiphany": "Épiphanie (Rois mages)",
      "andalusiaDay": "Jour de l'Andalousie",
      "maundyThursday": "Jeudi saint",
      "goodFriday": "Vendredi saint",
      "labourDay": "Fête du Travail",
      "sanJuan": "San Juan (Almería)",
      "assumption": "Assomption",
      "virgenDelMar": "Virgen del Mar (Almería)",
      "nationalDay": "Fête nationale espagnole",
      "allSaints": "Toussaint (reporté)",
      "constitutionDay": "Jour de la Constitution",
      "immaculate": "Immaculée Conception",
      "christmas": "Noël"
    },
    "calendar": {
      "addToCalendar": "Ajouter au calendrier",
      "icsDownload": "Apple / Outlook (.ics)",
      "icsHint": "Fichier calendrier universel",
      "googleCalendar": "Google Agenda",
      "googleHint": "S'ouvre dans un nouvel onglet"
    },
    "community": {
      "title": "Outils communautaires",
      "safetySub": "Voisins vérifiés, notes factuelles",
      "emergencySub": "Police, médical, 112",
      "holidaysSub": "Espagne & Andalousie 2026"
    }
  }
};

export default fr;
